export default class Local {
	constructor(_app) {
		this._back = _app.getService("backend");
		this._local = _app.getService("local");
		this._app = _app;
	}

	progressStart() {
		this._app.getService("progress").start();
	}
	progressEnd() {
		this._app.getService("progress").end();
	}

	addRole(obj) {
		this.progressStart();
		return Promise.all([this._back.addRole(obj), this._local.roles()]).then(
			data => {
				this.progressEnd();
				obj.id = data[0].id;
				data[1].add(obj);
				return obj;
			}
		);
	}

	addUser(obj) {
		this.progressStart();
		return Promise.all([this._back.addUser(obj), this._local.users()]).then(
			data => {
				this.progressEnd();
				obj.id = data[0].id;
				data[1].add(obj);
				return obj;
			}
		);
	}
	updateUser(id, obj) {
		this.progressStart();
		return Promise.all([
			this._back.updateUser(id, obj),
			this._local.users(),
		]).then(data => {
			this.progressEnd();
			data[1].updateItem(id, obj);
			return obj;
		});
	}
	deleteUser(id) {
		this.progressStart();
		return Promise.all([this._back.deleteUser(id), this._local.users()]).then(
			data => {
				this.progressEnd();
				data[1].remove(id);
				return id;
			}
		);
	}

	updateRole(id, obj) {
		this.progressStart();
		return Promise.all([
			this._back.updateRole(id, obj),
			this._local.roles(),
		]).then(data => {
			this.progressEnd();
			data[1].updateItem(id, obj);
			return obj;
		});
	}

	deleteRole(id) {
		this.progressStart();
		return Promise.all([this._back.deleteRole(id), this._local.roles()]).then(
			data => {
				this.progressEnd();
				data[1].remove(id);
				return id;
			}
		);
	}
}
